import { render, staticRenderFns } from "./index.vue?vue&type=template&id=70b0d8d2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=70b0d8d2&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70b0d8d2')) {
      api.createRecord('70b0d8d2', component.options)
    } else {
      api.reload('70b0d8d2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=70b0d8d2", function () {
      api.rerender('70b0d8d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/memberFreezeRecords/assembly/thaw/index.vue"
export default component.exports